export default __webpack_public_path__ + "static/media/gallery_01.e2b457a6.jpg";